export default __webpack_public_path__ + "static/media/BellIcon.17b91a25.svg";